
import React, { Fragment } from 'react';
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useRef, useState } from "react";

import API from "../api/axios.config";
import { useUser } from "../context/UserContext";
import authService from "../services/auth.service";
import EvolveMeHero from '../components/EvolveMeHero';
import ForgotPasswordModal from '../components/ForgotPasswordModal';



export default function Login() { 

   const [errorReg, setErrorReg] = useState("");
   const [errorLogin, setErrorLogin] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const { isLoggedIn, setUserState, setUserData, asaData } = useUser();
   const [redirectToReferrer, setRedirectToReferrer] = useState(false);
   const { state } = useLocation();

   const {
      register: registerLogin,
      formState: { errors: errorsLogin },
      handleSubmit: handleSubmitLogin,
    } = useForm({
      mode: "onTouched",
      reValidateMode: "onSubmit",
      defaultValues: {
        username: "",
        password: "",
      },
    });

    const {
      register: registerReg,
      formState: { errors: errorsReg },
      handleSubmit: handleSubmitReg,
    } = useForm({
      mode: "onTouched",
      reValidateMode: "onSubmit",
    });

   const onSubmitLogin = async (data) => {
      const { username, password } = data;
   
      try {
         setErrorLogin("");
         setIsLoading(true);
         const data = await authService.login(username, password);

         setTimeout(() => {
         setUserState(data);
         //setUserData(data);
         setRedirectToReferrer(true);
         setIsLoading(false);
         }, 1500); 
         
      } catch (errorLogin) {
         setIsLoading(false);
         setErrorLogin(errorLogin.response?.data.message);
      }
   };


   const onSubmitReg = async (data) => {
      const {firstname, lastname, username, email, birthday, password} = data;

      try {
         setErrorReg("");
         setIsLoading(true);

         const { data } = await API.post("/auth/signup", {
            firstname,
            lastname,
            username,
            email,
            birthday,
            password,
         });

         setTimeout(() => {
            console.log("Setting reg data:", data)
            setUserState(data);
            //setUserData(data);
            setRedirectToReferrer(true);
            setIsLoading(false);
            }, 1500); 
      } catch (errorReg){
         setIsLoading(false);
         setErrorReg(errorReg.response?.data.message);
      }

      };

      if (redirectToReferrer) {
         return <Navigate to={state?.from || "/home"} />;
       }
       if (isLoggedIn) {
         return <Navigate to={state?.from || "/home"} />;
       }    
      
   

   return(
      <Fragment>
         
         <Container className="p-5 rounded-lg m-5">
            <Row className="mb-5 text-center">
               <h1 style={{color:'#639fdd'}}> K-12 Student Platform </h1>
            </Row>

            {
               asaData ?  <EvolveMeHero />  : null 
            }

        
            
            <Row>
               <Col className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center bg-dark text-white p-5" 
                                    style={{ backgroundImage: "url(images/site/gears_1024.png)"}}>
                  <h3>
                    Welcome Back! 
                  </h3>
                  <p>Log into your account</p>
                  <Form onSubmit={handleSubmitLogin(onSubmitLogin)}>
                     <Form.Group className="mb-3" controlId="formLoginUsername">
                        <Form.Control type="input" placeholder="Username" 
                            {...registerLogin("username", {
                              required: "Username is required",
                              
                            })}
                        />  
                        {errorsLogin.username && (
                           <Form.Text className="text-danger">
                           {errorsLogin.username.message}
                           </Form.Text>
                        )}                     
                     </Form.Group>
                     <Form.Group className="mb-3" controlId="formLoginPassword">
                        <Form.Control type="password" placeholder="Password" 
                           {...registerLogin("password", {
                              required: "Password is required",
                              
                           })}
                        />
                        {errorsLogin.password && (
                           <Form.Text className="text-danger">
                           {errorsLogin.password.message}
                           </Form.Text>
                        )}  
                     </Form.Group>
                     <Form.Group>
                        <Button variant="primary" type="submit">
                           Sign In
                        </Button>  
                        {errorLogin && (
                           <Form.Text className="text-danger">
                           {errorLogin}
                           </Form.Text>
                        )}  
                     </Form.Group>
                     <ForgotPasswordModal />    
                  </Form>
                  
                  
               </Col>
               <Col className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center square border border-dark p-5">
                  <h3>
                     New to MindAntix?
                  </h3>
                  <p>Registration is simple!</p>
                  <Form onSubmit={handleSubmitReg(onSubmitReg)}>
                     <Row className="mb-3">
                        <Form.Group as={Col} controlId="formRegFName">
                           <Form.Control type="input" placeholder="First Name" 
                              {...registerReg("firstname", {
                                 required: "First name is required",
                                 
                               })}
                           />
                           {errorsReg.firstname && (
                           <Form.Text className="text-danger">
                           {errorsReg.firstname.message}
                           </Form.Text>
                           )}   
                        </Form.Group>

                        <Form.Group as={Col} controlId="formRegLName">
                           <Form.Control type="input" placeholder="Last Name" 
                              {...registerReg("lastname", {
                                 required: "Last name is required",
                                 
                               })}
                           />
                           {errorsReg.lastname && (
                           <Form.Text className="text-danger">
                           {errorsReg.lastname.message}
                           </Form.Text>
                           )}   
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        <Form.Group as={Col} controlId="formRegBirthday">
                           <Form.Control type="date" placeholder="Birthday (yyyy-mm-dd)" 
                              {...registerReg("birthday", {
                                 required: "Birthday is required",
                               })}
                           />
                           {errorsReg.birthday && (
                           <Form.Text className="text-danger">
                           {errorsReg.birthday.message}
                           </Form.Text>
                           )} 
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        <Form.Group as={Col} controlId="formRegEmail">
                           <Form.Control type="email" placeholder="Enter email" 
                              {...registerReg("email", {
                                 required: "Email is required",
                                 pattern: {
                                    // eslint-disable-next-line no-useless-escape
                                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                    message: "Email not valid",
                                  },
                               })}
                           />
                           {errorsReg.email && (
                           <Form.Text className="text-danger">
                           {errorsReg.email.message}
                           </Form.Text>
                           )} 
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        <Form.Group as={Col} controlId="formRegUsername">
                           <Form.Label>Select a username</Form.Label>
                           <Form.Control type="input" placeholder="Username" 
                              {...registerReg("username", {
                                 minLength: {
                                    value: 4,
                                    message: "Username must be greater than 3 characters",
                                  },
                                  
                                 required: "Username is required",
                                 pattern: {
                                    value: /^[a-zA-Z0-9]+$/,
                                    message: "Username cannot contain spaces or special characters"
                                    },
                                 
                               })}
                           />
                           {errorsReg.username && (
                           <Form.Text className="text-danger">
                           {errorsReg.username.message}
                           </Form.Text>
                           )} 
                        </Form.Group>
                     </Row>

                     <Form.Group className="mb-3" controlId="formRegPassword">
                        <Form.Text className="text-muted">
                           Password must be 8-20 characters long, must include lower, upper, number, and special chars !@#$%&*
                        </Form.Text>
                        <Form.Control type="password" placeholder="Password" 
                           {...registerReg("password", {
                              minLength: {
                                 value: 8,
                                 message: "Password must have at least 8 characters",
                               },
                              required: "Password is required",
                              validate: (value) => {
                                 return (
                                   [/[a-z]/, /[A-Z]/, /[0-9]/, /[!@#$%&*]/].every((pattern) =>
                                     pattern.test(value)
                                   ) || "must include lower, upper, number, and special chars"
                                 );
                               },
                              
                            })}
                        />
                        {errorsReg.password && (
                           <Form.Text className="text-danger">
                           {errorsReg.password.message}
                           </Form.Text>
                           )} 
                     </Form.Group>
                     <Form.Group className="mb-3" controlId="formBasicCheckbox">
                        <Form.Check className="small" type="checkbox" label={
                           <span> I agree to the <a href="/tos" target="_blank"> Terms of Service</a> and <a href="/privacy" target="_blank"> Privacy Policy </a></span>} 
                           {...registerReg("tos", {
                              required: "Accept ToS and Privacy agreement to continue",
                              
                            })}
                        />
                        {errorsReg.tos && (
                           <Form.Text className="text-danger">
                           {errorsReg.tos.message}
                           </Form.Text>
                           )} 
                     </Form.Group>
                     <Form.Group>
                        <Button variant="primary" type="submit">
                           Sign Up
                        </Button>  
                        {errorReg && (
                           <Form.Text className="text-danger">
                           {errorReg}
                           </Form.Text>
                        )}  
                     </Form.Group>   
                  </Form>
               </Col>
            </Row>
         </Container>
      </Fragment> 
   )
}